/**
 * @class {T.Phone.Select}
 * @extends {T.Form.Base}
 * @param {T.Form.Phone.Par|Object} par
 */
T.Form.Phone = Class(
	/**
	 * @lends {T.Form.Phone#}
	 */
	{
		__NAME: 'T.Form.Phone',
		_isOpened: false,

		/**
		 * @param {T.Form.Phone.Par|Object} par
		 * @constructs
		 */
		__construct: function(par){
			this._change = par.onChange || D.doNothing;

			this.node = mkE({
				tag: 'div',
				className: 'phone-form',
				els: [
					this._captionNode = mkE({
						tag: 'label',
						className: 'hidden'
					}),
					this._itemNode = mkE({
						tag: 'div',
						className: 'phone-container',
						els: [
							{
								tag: 'div',
								className: 'phone-select',
								els: [
									this._valueText = mkE({
										tag: 'div',
										className: 'select-value'
									}),
									this._select = mkE({
										tag: 'select',
										className: 'form-control',
										prop: {
											onchange: this._onSelectChange,
											onkeyup: this._onSelectKeyup,
											onmouseup: this._onSelectMouseUp,
											onblur: this._onSelectBlur
										}
									})
								]
							},
							{
								tag: 'div',
								className: 'phone-input',
								els: [
									this._input = mkE({
										tag: 'input',
										type: 'tel',
										attr: {
											autocomplete: false
										}
									})
								]
							}
						]
					}),
					this._getErrorNode(),
					this._getHelpNode()
				]
			});

			if( par.border ){
				addClassName(this.node, 'phone-border');
			}

			if( par.dark ){
				addClassName(this.node, 'phone-dark');
			}

			for( let i = 0, l = D.callingCodes.length; i < l; i++ ){
				let code = D.callingCodes[i];
				mkE({
					tag: 'option',
					attr: {
						value: code
					},
					text: code
				}).append(this._select);
			}

			this._par(par);
			this.value(par.code || null, par.value || null);
		},

		value: function(s, i){
			if( isset(s) ){
				this._select.value = s;
				this._onSelectChange();
			}
			if( isset(i) ){
				this._input.value = i;
			}
			if( !this._select.value || !this._input.value ){
				return null;
			}
			return {
				code: this._select.value,
				value: this._input.value
			};
		},

		_onSelectChange: function(){
			setNodeText(this._valueText, "+" + String(this._select.value));
			setTimeout(this._onSelectChangeRemove, 60);
		},

		_onSelectChangeRemove: function(){
			removeClassName(this.node, 'select-opened');
			this._isOpened = false;
			document.removeEventListener('mouseup', this._documentMouseUp);
		},

		_onSelectKeyup: function(e){
			if( !this._isOpened ){
				this._select.blur();
			}else{
				if(e.which === 13 || e.which===27 ){
					this._onSelectChange();
				}
			}
		},

		_onSelectBlur: function(){
			console.log('remove select blur');
			removeClassName(this.node, 'select-opened');
			this._isOpened = false;
		},

		_onSelectMouseUp: function(e){
			if( this._isOpened ){
				return;
			}
			console.log('add select up');
			addClassName(this.node, 'select-opened');
			this._isOpened = true;
			e.stopPropagation();
			document.addEventListener('mouseup', this._documentMouseUp);
		},

		_documentMouseUp: function(e){
			if( e.target != this._select && !in_array(e.target, this._select.childNodes) ){
				this._select.blur();
			}else{
				this._onSelectChange();
			}
		}
	},
	T.Form.Base
);

/**
 * @class {T.Form.Phone.Par}
 * @extends {T.Form.Base.Par}
 */
T.Form.Phone.Par = Class(
	/**
	 * @lends {T.Form.Phone.Par#}
	 */
	{
		__NAME: 'T.Form.Phone.Par',

		code: null,
		value: null,
		onChange: D.doNothing,
		border: false,
		dark: false
	},
	T.Form.Base.Par
);